/**
 * RiderAccountingPage API
 * 라이더 출금제한 관련 API 함수들
 */
import { apiClient } from "@/shared/api/client";
import { RiderListItem, RiderSearchFilters, ContractStatusOption } from "../types/riderAccounting.types";

const BASE_PATH = '/api/v1/withdrawal-limit/rider';

/**
 * RiderAccountingPage API 서비스
 */
export const riderAccountingApi = {
    /**
     * 계약상태 코드 조회 (드롭박스용)
     * GET /api/v1/withdrawal-limit/contract-status/codes
     */
    getContractStatusCodes: async (): Promise<ContractStatusOption[]> => {
        const response = await apiClient.get<ContractStatusOption[]>('/api/v1/withdrawal-limit/contract-status/codes');
        return response.data;
    },
    /**
     * 라이더 목록 조회
     * GET /api/v1/withdrawal-limit/rider/list
     */
    getRiderList: async (): Promise<RiderListItem[]> => {
        const response = await apiClient.get<RiderListItem[]>(
            `${BASE_PATH}/list`
        );
        return response.data;
    },

    /**
     * 라이더 검색
     * GET /api/v1/withdrawal-limit/rider/search
     */
    searchRiders: async (filters: RiderSearchFilters): Promise<RiderListItem[]> => {
        const response = await apiClient.get<RiderListItem[]>(
            `${BASE_PATH}/search`,
            { params: filters }
        );
        return response.data;
    },

    /**
     * 라이더 출금제한 설정
     * POST /api/v1/withdrawal-limit/rider/withdrawal
     */
    updateWithdrawalStatus: async (riderId: string, suppId: string, withdrawalYn: 'Y' | 'N'): Promise<void> => {
        await apiClient.post<void>(
            `${BASE_PATH}/withdrawal`,
            {
                riderId,
                suppId,
                withdrawalYn
            }
        );
    }
};
